export default __webpack_public_path__ + "static/media/0x4c888e116d57a32f84865f3789dcb131fdc9fab6.08cb027d.svg";